import type { NodeViewProps } from '@tiptap/core';
import type { FC } from 'react';
import { LatexComponent } from '../../../latex';
import * as clipboard from 'clipboard-polyfill';
import { message } from '../../../components/message';
import { useChatTranslation } from '../../hooks/use-i18n';

export const Equation: FC<NodeViewProps> = (props) => {
  const { t } = useChatTranslation();
  if (!props.node.attrs) return null;
  return (
    <LatexComponent
      className="inline-flex items-center animate-click"
      inline={props.node.attrs.isInlineLatex}
      text={props.node.attrs.latex}
      onClick={() => {
        void clipboard.writeText(props.node.attrs.latex);
        message.success(t('chatCopied'));
      }}
    />
  );
};
